import type { HTMLAttributes, ReactNode } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
  title?: string;
  eyebrow?: string;
  footer?: ReactNode;
}

export function Card({ children, className = '', title, eyebrow, footer, ...props }: CardProps) {
  return (
    <div
      className={`rounded-[1.5rem] border border-[rgba(201,169,110,0.18)] bg-[linear-gradient(180deg,rgba(15,15,24,0.95),rgba(10,10,15,0.9))] p-5 shadow-[0_20px_80px_rgba(0,0,0,0.35)] ${className}`.trim()}
      {...props}
    >
      {(eyebrow || title) && (
        <div className="mb-4">
          {eyebrow ? (
            <p className="text-[0.7rem] uppercase tracking-[0.3em] text-[var(--la-text-muted)]">
              {eyebrow}
            </p>
          ) : null}
          {title ? (
            <h3 className="font-heading text-xl text-[var(--la-text)]">{title}</h3>
          ) : null}
        </div>
      )}
      <div>{children}</div>
      {footer ? <div className="mt-4 border-t border-white/5 pt-4">{footer}</div> : null}
    </div>
  );
}
